const style = {
  display: 'inline-block',
  margin: '0rem 1.2rem 2rem 0rem',
  padding: 0,
  verticalAlign: 'top',
  width: '19.5rem',
};

export default style;
